module.exports = __webpack_public_path__ + "static/media/sell_finish_service_make_1.31aa6d7c.jpg";